import classNames from 'classnames';
import { Icon } from 'src/components/Icon';
import XClose from 'src/assets/svgicons/line/x-close.svg';

type Props = {
  onClick: () => void;
  className?: string;
};

const ModalCloseButton: React.FunctionComponent<Props> = ({
  onClick,
  className,
}) => {
  return (
    <button
      onClick={onClick}
      className={classNames(
        'appearance-none cursor-pointer text-purple-800',
        className
      )}
    >
      <Icon>
        <XClose />
      </Icon>
    </button>
  );
};

export default ModalCloseButton;
